var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImentorMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 163181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.2307 28.6853L0 22.2307L6.47366 0L28.7043 6.45468L22.2307 28.6853ZM3.36023 20.3892L20.4082 25.3441L25.3631 8.29616L8.31514 3.34124L3.36023 20.3892Z",
    fill: "#1373E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.3714 12.3965C15.4725 12.3965 16.3268 13.2508 16.3268 14.3519C16.3268 15.453 15.4725 16.3073 14.3714 16.3073C13.2703 16.3073 12.416 15.453 12.416 14.3519C12.435 13.2508 13.2893 12.3965 14.3714 12.3965ZM13.0235 17.6931H15.7193V30.2038H13.0235V17.6931Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImentorMobile);
export default __webpack_public_path__ + "static/media/imentor_mobile.f15d6f77e4b50942e86ce6ae04573db2.svg";
export { ForwardRef as ReactComponent };